import misRutas from 'vue-routes-generator'
import WebmailMain from './webmail.component'
import Store from './store'
import MainStore from '../../core/vue/store/stores'
import Redactar from './components/redactar/redactar'

export default {
	install: Vue => {
		misRutas.route('/main').child('webmail', {
			name: 'Webmail',
			component: WebmailMain
		})

		misRutas.route('/main').child('webmail/:buzon', {
			name: 'Buzón',
			component: WebmailMain
		})

		misRutas.route('/main').child('webmail/:buzon/:mensaje', {
			name: 'Mensaje',
			component: WebmailMain
		})

		MainStore.registerModule(['webmail'], Store)

		Vue.component('redactar-email', Redactar)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/webmail/vue/index.js